import styles from "../Home.module.css";
import Report from "../components/Report";

export default function Home({openReport1, openReport2, openReport3, openReport4}) {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <header className={styles.header}>
          <div className={styles.logo}>
            <h1>U.S. NAVAL AERO</h1>
          </div>

          <div>
            <h2>FA/18 Maintenance Reports</h2>
            <p className={styles.lead}>
              Navigate below to view the ledger home page or individual reports.
            </p>
          </div>

          <div className={styles.headerRight}>
            <div className={styles.stamp}>CLASSIFIED — TECH ONLY</div>
            <div className={styles.form}>Form: FM-18-INDEX</div>
          </div>
        </header>

        <section className={styles.reports}>
          <Report
            onClick = {openReport1}
            title="Report 1 — Engine Run"
            meta="FA/18 BuNo 94512 • June 12, 2015 • NAS Corpus Christi"/>
          <Report
            onClick = {openReport2}
            title="Report 2 — Landing Gear Service"
            meta="FA/18 BuNo 94512 • June 14, 2015 • Materiel Depot"
          />
          <Report
            onClick = {openReport3}
            title="Report 3 — Avionics Test"
            meta="FA/18 BuNo 94512 • June 20, 2015 • Hangar 3"
          />
          <Report
            onClick = {openReport4}
            title="Report 4 — Field Note"
            meta="FA/18 BuNo 94512 • June 28, 2015 • Auxiliary Airfield"
          />
        </section>

        <footer className={styles.footer}>
          <div>
            Ledger prepared by — FA/18 Service Section • Naval Air Station — circa
            2015
          </div>
        </footer>
      </div>
    </div>
  );
}
